<div class="play-video-wrap" *ngIf="videoSrc" [class.play-video-wrap--preload]="!shouldPlay">
  <div class="play-video-stage">
    <div
      class="start-overlay"
      *ngIf="shouldPlay && showStartOverlay && !hasError"
      role="button"
      tabindex="0"
      (click)="startWithSound()"
      (keydown.enter)="startWithSound()"
      (keydown.space)="startWithSound()">
      <div class="start-overlay-inner">
        <span class="start-overlay-icon" aria-hidden="true">&#9658;</span>
        <span class="start-overlay-text">Tap to play with sound</span>
      </div>
    </div>

    <div class="buffer-overlay" *ngIf="shouldPlay && isBuffering && !showStartOverlay && !hasError" aria-live="polite">
      <span class="buffer-spinner" aria-hidden="true"></span>
      <span>Loading video…</span>
    </div>

    <div class="error-overlay" *ngIf="shouldPlay && hasError">
      <p>We couldn't start the video.</p>
      <button type="button" class="error-retry" (click)="retry()">Try again</button>
    </div>

    <video
      #videoPlayer
      class="webinar-video"
      controls
      playsinline
      webkit-playsinline
      preload="auto"
      muted
      [src]="videoSrc"
      [attr.poster]="posterUrl || null"
      [ngStyle]="{ 'max-height': isMobileView ? '50vh' : '70vh' }"
      (playing)="onPlaying()"
      (waiting)="onWaiting()"
      (canplay)="onCanPlay()"
      (ended)="onEnded()"
      (error)="onError()">
    </video>
  </div>
</div>
